
import { Injectable } from "@angular/core";
import { Graph } from "../models/itens.model";
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Injectable()
export class SharedService {

    patternStatus = [
        { id: '1',  color: 'rgb(144, 157, 173)' }, // Não Iniciado
        { id: '2-1', color: 'rgb(139, 163, 62)'}, // Normal
        { id: '2-2', color: 'rgb(232, 209, 102)'}, //Requer Atenção
        { id: '2-3', color: 'rgb(193, 55, 75)'}, //Com problemas
        { id: '3', color: 'rgb(54, 88, 157)'}, //Concluído
        { id: 'Não Informado', color: 'rgb(207, 213, 220)'} //Não Informado
    ];
    patternAchievement = [
        { id: '1',  color: 'rgb(139, 163, 62)' }, // Superior
        { id: '2',  color: 'rgb(232, 209, 102)' }, // Entre
        { id: '3',  color: 'rgb(193, 55, 75)' }, // Inferior
        { id: '0',  color: 'rgb(207, 213, 220)' } // Não iniciado;
    ];
    patternProjection = [
        { id: '1',  color: 'rgb(139, 163, 62)' }, // Superior
        { id: '2',  color: 'rgb(232, 209, 102)' }, // Entre
        { id: '3',  color: 'rgb(193, 55, 75)' }, // Inferior
        { id: '0',  color: 'rgb(207, 213, 220)' } // Não iniciado;
    ];
    constructor() {
    }
    
    getGraph(value, print:boolean = false) {
        var graphData: Graph = this.generateGraphData(value);
        var graph:object = {};
        if (graphData) {
        graph['chartOptions'] = {
            responsive: !print,
            maintainAspectRatio: print,
        };
        graph['chartLabels'] = [];
        graph['chartData'];
        graph['chartType'] = graphData?.type_graph == 2 ? 'line' : 'bar';
        graph['chartMeta'] = [];
        graph['chartRealizado'] = [];

        graphData.itens.forEach((item, index) => {
            if (index != 0) {
            graph['chartLabels'].push(item[0]);
            graph['chartMeta'].push(item[1]);
            graph['chartRealizado'].push(item[2]);
            }
        })

        graph['chartData'] = {
            labels: graph['chartLabels'],
            datasets: [
            {
                data: graph['chartMeta'],
                label: graphData.itens[0][1],
                pointRadius: 5,
                order: 1
            },
            {
                data: graph['chartRealizado'],
                label: graphData.itens[0][2],
                pointRadius: 5,
                order: 0
            },
            ],
        };
        }
        graph['viewInfoActive'] = true;
        return graph;
    }

    generateGraphData(value){
        var result: [string, any, any][] = [['', 'Meta', 'Realizado']];
        var type = null;
        if (value?.accum_table == 1) {
            var done = 0;
            var goal = 0;
            if (value?.table_mod_id == 1) {
                for (let i = 1; i <= value?.period_mod_id; i++) {
                    var month = this.getMonth(value, i);
                    var indTable = value?.pf_ind_table.find(p => p.month == i);
                    var g = indTable?.goal || 0;
                    var d = indTable?.done || 0;
                    goal += +g;
                    done += +d;
                    var isNumericGoal = g > 0 ? goal : null;
                    var isNumericDone = d > 0 ? done : null;
                    result.push([month, isNumericGoal, isNumericDone]);
                }
            } else {
                var deno = 0;
                var nume = 0;
                for (let i = 1; i <= value?.period_mod_id; i++) {
                var month = this.getMonth(value, i);
                var indTable = value?.pf_ind_table.find(p => p.month == i);
                if (indTable?.denominator) {
                    deno += +indTable?.denominator;
                }
                if (indTable?.numerator) {
                    nume += +indTable?.numerator;
                }
                if (indTable?.denominator === null || indTable?.numerator === null) {
                    done = null;
                } else {
                    if (nume == deno) {
                    done = 100;
                    } else {
                    if (deno > 0) {
                        done = (nume * 100) / (deno);
                    } else {
                        done = 0;
                    }
                    }
                }
                if (!isNaN(indTable?.goal)) {
                    goal = indTable?.goal;
                } else {
                    goal = null;
                }
                result.push([month, goal, done]);
                }
            }
        } 
        else {
        for (let i = 1; i <= value?.period_mod_id; i++) {
            var month = this.getMonth(value, i);
            var indTable = value?.pf_ind_table.find(p => p.month == i);
            goal = indTable?.goal ?? null;
            done = indTable?.done ?? null;
            result.push([month, goal, done]);
        }
        }
        if (value?.accum || value?.accum_table) {
            type = 2;
        } else {
            type = 1;
        }
        return {'results': 0, 'itens': result, 'type_graph': type};
    }

    getMonth(data, currentMonth){
        var monthList = [
          { "id": 1, "label": "Janeiro" },
          { "id": 2, "label": "Fevereiro" },
          { "id": 3, "label": "Março" },
          { "id": 4, "label": "Abril" },
          { "id": 5, "label": "Maio" },
          { "id": 6, "label": "Junho" },
          { "id": 7, "label": "Julho" },
          { "id": 8, "label": "Agosto" },
          { "id": 9, "label": "Setembro" },
          { "id": 10, "label": "Outubro" },
          { "id": 11, "label": "Novembro" },
          { "id": 12, "label": "Dezembro" }
        ];
        var suf = [
          { "id": 12, "label": "Men" },
          { "id": 6, "label": "Bim" },
          { "id": 4, "label": "Tri" },
          { "id": 3, "label": "Qua" },
          { "id": 2, "label": "Sem" },
          { "id": 1, "label": "Anu" }
        ];
    
        if([1, 2, 12].includes(data['period_mod_id'])){
          
          var month = monthList.find(m => currentMonth == m.id)?.label;
          return month.substr(0, 3) + (data['year']? "/" + data['year'] : '');
        }
        else{
          var period = suf.find(s=> s.id == data['period_mod_id']);
            if (period) {
                return currentMonth + "º" + period['label'] + (data['year']? "/" + data['year'] : '');
            }
        }
    }
      
    
    getGraphGoalData(data, pattern, print:boolean = false){
        var result = [];
        data?.forEach(function(a){
            var datasets  = []
            pattern?.forEach(function(p) {
                var ds = { 
                label: '', 
                data:  [], 
                backgroundColor: p.color,
                borderWidth: 3,  
                borderColor: '#fff',
                borderRadius: {topLeft:16, topRight: 16, bottomLeft:16, bottomRight: 16}, 
                borderSkipped: false,
                };
                var l = a.data[p.id];
                if(l){
                    if(!ds['label']){
                        ds['label'] = l['label'];
                    }
                    ds['data'].push(l.total);
                }
                if(l?.total > 0){
                datasets.push(ds);
                }
            });
            let maxSize = 0;
            datasets?.forEach(dataset => {
                // console.log(dataset.data)
                const localMax = Math.max(...dataset.data);
                maxSize += localMax;
            });
            var newChart = {
                type: 'bar',
                data: {
                    labels:[a.name],
                    datasets: datasets
                },
                zoomOutPercentage: 30,
                aspectRatio: 1,
                layout: {
                    padding: 0, // Remove todo o padding extra ao redor do gráfico
                },
                options:{
                    responsive: !print,
                    maintainAspectRatio: print,
                    indexAxis: 'y', 
                    barPercent: 1,
                    categoryPercentage:1,
                    scales: {
                        x: {
                            stacked: true, 
                            min: 0,
                            max: maxSize,
                            ticks: { display: false,},
                            grid: { 
                                drawBorder: false, 
                                display: false ,
                                drawOnChartArea: false,
                                drawTicks: false 
                            }
                        },
                        y: {
                            stacked: true, 
                            ticks: { display: false,},
                            grid: {
                                drawBorder: false, 
                                display: false ,
                                drawOnChartArea: false,
                                drawTicks: false 
                            }
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltips: {
                            enabled: false
                        },
                        datalabels: {
                            display: true,
                            color: '#fff', 
                            font: {
                                size: print? 20 : 30,
                                weight: 'bold'
                            }
                        },
                    },
                },
                plugins:[ChartDataLabels]
            }
            result.push(newChart);
        });
        return result;
    }
    

  filterData(filter, data){
    var keys = filter.agency_id;
    var result = Object.entries(data).map(([key, value]) => {
        value['pf_indicator'] = value['pf_indicator']?.filter(pfi => {
        var indA = pfi['ind_analysis_stat_id'] ?? [];
        var curT = pfi['current_table_status'] ?? [];
        return (
            indA.some(v => filter?.pf_ind_analysis_stat_id?.includes(v ?? 0)) &&
            curT.some(v => filter?.pf_ind_current_table_status?.includes(v ?? 0))
        );
        });
        return [key, value];
    })
    .filter(([key, value]) => 
        filter?.agency_id.includes(Number(key)) &&
        value['pf_indicator']?.length > 0
    )
    .reduce((acc: Record<string, any>, [key, value]) => {
        value['total'] = value['pf_indicator']?.length ?? 0;
        acc[key as string] = value;
        return acc;
    }, {} as Record<string, any>);

    return result;

  }
  filterData2(filter, data){
    var keys = filter.agency_id;
    var result = data.map((value) => {
        var newData = Object.entries(value.data).map(([key, va]) => {
            va['pf_indicator'] = va['pf_indicator']?.filter(pfi => {
                var indA = pfi['ind_analysis_stat_id'] ?? [];
                var curT = pfi['current_table_status'] ?? [];
                return (
                    indA.some(v => filter?.pf_ind_analysis_stat_id?.includes(v ?? 0)) &&
                    curT.some(v => filter?.pf_ind_current_table_status?.includes(v ?? 0))
                );
            });
            return [key, va];
        }).filter(([key, va]) => 
            va['pf_indicator']?.length > 0
        ).reduce((acc: Record<string, any>, [key, va]) => {
            va['total'] = va['pf_indicator']?.length ?? 0;
            acc[key as string] = va;
            return acc;
        }, {} as Record<string, any>);
        return {...value, 'data': newData}
    }).filter((value) => 
        filter?.agency_id.includes(Number(value.id))
    );
    const sortData = result.sort((a, b) => {
        if (a.nro_ord_parent === b.nro_ord_parent) {
          return a.nro_ord_child - b.nro_ord_child;
        }
        return a.nro_ord_parent - b.nro_ord_parent;
      });
    return sortData;

  }
}